import { render, staticRenderFns } from "./ExamineButton.vue?vue&type=template&id=0c5123c3&scoped=true&"
import script from "./ExamineButton.vue?vue&type=script&lang=js&"
export * from "./ExamineButton.vue?vue&type=script&lang=js&"
import style0 from "./ExamineButton.vue?vue&type=style&index=0&id=0c5123c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5123c3",
  null
  
)

export default component.exports